import { render, staticRenderFns } from "./GeneRate.vue?vue&type=template&id=131b5902&scoped=true"
import script from "./GeneRate.vue?vue&type=script&lang=js"
export * from "./GeneRate.vue?vue&type=script&lang=js"
import style0 from "./GeneRate.vue?vue&type=style&index=0&id=131b5902&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131b5902",
  null
  
)

export default component.exports